import React from 'react';

const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => {
      const entry = {
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name
      };
      // Google requires: last item must NOT have "item" (URL) property
      if (index < items.length - 1) {
        entry.item = `https://energyperformancedirect.co.uk${item.path}`;
      }
      return entry;
    })
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default BreadcrumbSchema;
